import React from "react";
import axios from "../../axios-data";
import { Timer } from "../../helpers/timer";
import {
  Box,
  Card,
  CardHeader,
  HStack,
  Text,
  Button,
  Center,
  PinInput,
  PinInputField,
  Alert,
  AlertIcon,
  AlertDescription,
} from "@chakra-ui/react";
import { analytics } from "../../services";

class email extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      verificationCode: "",
      isValidated: false,
      codeValid: false,
      timerInSeconds: null,
      linkDisabled: true,
      showError: false,
      isLoading: false,
    };
    this.verifyEmail = this.verifyEmail.bind(this);
    this.resendCode = this.resendCode.bind(this);
  }

  singleUpdate() {
    if (this.props.currentStep === 4) {
      analytics.track("Email", "Wizard", { page: 4 });
      //Allows for use on single DidUpdate
      this.singleUpdate = function () {};
    }
  }

  componentDidUpdate() {
    const resendButton = document.getElementById("resendButton");
    if (resendButton) {
      if (!this.state.timerInSeconds) {
        this.startTimer();
      }
      setInterval(() => {
        if (!this.state.codeValid) {
          this.setState({
            timerInSeconds: Timer.getTime() / 1000,
            linkDisabled: true,
          });
        }
        if (this.state.timerInSeconds > 60) {
          this.setState({ linkDisabled: false });
        }
      }, 1000);
    }
  }

  verifyEmail() {
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.props["token"],
    };
    let form = {
      type: 0,
      email: this.props.email,
      code: this.state.verificationCode,
    };
    axios
      .post("/register/validatecode", form, { headers: headers })
      .then((resp) => {
        if (resp.data) {
          this.setState({
            codeValid: resp.data,
            isValidated: true,
          });
          this.props.onContinue();

          Timer.stop();
        } else {
          this.setState({ showError: true, isLoading: false });
        }
      });
  }

  resendCode() {
    this.setState({ timerInSeconds: 0 });
    this.startTimer();

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.props["token"],
    };

    axios
      .post(
        `/Register/SendVerification`,
        { email: this.props.email },
        {
          headers: headers,
        }
      )
      .catch((error) => {
        analytics.report(error, {
          email: this.state.email,
          lastName: this.state.lastName,
        });
      });
  }
  startTimer() {
    Timer.stop();
    Timer.start();
  }

  render() {
    if (this.props.currentStep !== 4) {
      return null;
    }

    return (
      <React.Fragment>
        <Box bg="#EBF9FF">
          <Center>
            <Card mt={10} mb={10} maxW={"480px"} boxShadow="xl" p={10}>
              <CardHeader>
                <Text textStyle="t6" as="b" color="pb100">
                  Verify your email
                </Text>
              </CardHeader>
              <Box ml={5}>
                <Text textStyle="b2">
                  Keep this window open while you check your email! Enter the
                  verification code we sent to{" "}
                  <strong>{this.props.email}</strong>. Remember to check your
                  spam folder if you don’t see the code. If you still haven’t
                  received the code after 1 minute, try resending it.
                </Text>
              </Box>{" "}
              <Center>
                <Box m={8}>
                  <Text textStyle="b2" mb={2}>
                    Verification Code{" "}
                    <Text as="span" color="sr60">
                      *
                    </Text>
                  </Text>

                  <HStack>
                    <PinInput
                      errorBorderColor="sr60"
                      isInvalid={this.state.showError}
                      otp
                      autoFocus
                      size="lg"
                      onChange={(e) => this.setState({ verificationCode: e })}
                    >
                      <PinInputField borderColor="pg50" />{" "}
                      <PinInputField borderColor="pg50" />
                      <PinInputField borderColor="pg50" />
                      <PinInputField borderColor="pg50" />
                      <PinInputField borderColor="pg50" />
                      <PinInputField borderColor="pg50" />
                    </PinInput>
                  </HStack>
                  {this.state.showError && (
                    <Box maxW={"20.5rem"}>
                      <Alert mt={5} bg="transparent" status="error" size="sm">
                        {" "}
                        <AlertIcon color="sr60" />
                        <Box>
                          <AlertDescription color="sr60">
                            Hmm, that's not the right code. Please check the
                            verification code and try again.
                          </AlertDescription>
                        </Box>
                      </Alert>
                    </Box>
                  )}
                  <Box mt={4}>
                    <Button
                      id="resendButton"
                      variant="link"
                      style={
                        this.state.linkDisabled
                          ? {
                              color: "gray",
                              backgroundColor: "white",
                              textDecoration: "none",
                              cursor: "not-allowed",
                            }
                          : {
                              textDecoration: "underline",
                              color: "#0065E0",
                              backgroundColor: "white",
                            }
                      }
                      onClick={() => {
                        if (!this.state.linkDisabled) {
                          this.setState({ linkDisabled: true });
                          this.resendCode();
                        }
                      }}
                      onFocus={(e) => e.target.blur()}
                    >
                      Resend Code
                    </Button>
                  </Box>
                </Box>
              </Center>{" "}
              <Center>
                <Button
                  m={4}
                  mb={8}
                  mt={4}
                  w="100%"
                  isLoading={this.state.isLoading}
                  isDisabled={this.state.verificationCode.length !== 6}
                  onClick={() => {
                    this.setState({ isLoading: true });
                    this.verifyEmail();
                  }}
                >
                  {" "}
                  Continue
                </Button>{" "}
              </Center>
            </Card>
          </Center>
        </Box>
      </React.Fragment>
    );
  }
}

export default email;
